// Meta Pixel tracking helper
// Pixel ID: 966263356035957

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '966263356035957'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any, t: HTMLScriptElement, s: HTMLScriptElement
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e) as HTMLScriptElement
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement | undefined
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Inject the <noscript> fallback image
  if (!document.getElementById('fb-pixel-noscript')) {
    const noscript = document.createElement('noscript')
    noscript.id = 'fb-pixel-noscript'
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }
}

export function trackEvent(
  event: 'PageView' | 'ViewContent' | 'InitiateCheckout' | string,
  data?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  if (data) {
    window.fbq('track', event, data)
  } else {
    window.fbq('track', event)
  }
}
